/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { accountsUpdateSettings } from "../../funcs/accountsUpdateSettings.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .PutApiLeadScraperMicroserviceApiV1AccountsSettingsRequestBody$inboundSchema,
};

export const tool$accountsUpdateSettings: ToolDefinition<typeof args> = {
  name: "accounts_update-settings",
  description: `Update account settings

Updates the settings for a given account`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await accountsUpdateSettings(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
